import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {cx} from '@emotion/css';
import {getPageRoute} from '../../../utils/routes/getPageRoute';
import CardLink from '../../DesignSystem/CardLink/CardLink';
import {ReactComponent as InsuranceIcon} from '../../../images/icons/shieldedTick.svg';
import {ReactComponent as EnergyIcon} from '../../../images/icons/boltInsideCircle.svg';
import {useLocale} from '../../../RootProvider/LocaleContext';
import RichText from '../../DesignSystem/Text/RichText/RichText';
import {Alignment, SupplierType, ContentfulContent} from '../../../types';
import SectionTitleAndSubtitle from '../../DesignSystem/SectionTitleAndSubtitle/SectionTitleAndSubtitle';

import styles from './BusinessServices.styles';

export interface BusinessServicesProps {
  title: string;
  description: ContentfulContent;
  slug: string;
  cardTitle: string;
  cardDescription: string;
  type: SupplierType;
}

function BusinessServices({
  title,
  description,
  slug,
  cardTitle,
  cardDescription,
  type,
}: BusinessServicesProps): ReactElement {
  const locale = useLocale();

  const {formatMessage} = useIntl();

  const getIcon = () => {
    switch (type) {
      case SupplierType.INSURANCE:
        return (
          <InsuranceIcon width="32" height="32" data-testid={`ui.homepageSupplier.${SupplierType.INSURANCE}Icon`} />
        );
      default:
        return <EnergyIcon width="32" height="32" data-testid={`ui.homepageSupplier.${SupplierType.ENERGY}Icon`} />;
    }
  };

  return (
    <div className={cx(styles.businessServices)}>
      <div className={cx(styles.container)}>
        <SectionTitleAndSubtitle
          title={title}
          section={formatMessage({id: 'homepage.businessServices.subtitle'})}
          alignment={Alignment.CENTER}
        />
        <RichText className={cx(styles.subtitle)} content={description} />
      </div>
      <div className={cx(styles.cardLink)}>
        <CardLink
          href={getPageRoute('partners.supplier.partner', locale, {
            contentfulSlug: slug,
          })}
          label={cardTitle}
          description={cardDescription}
          icon={getIcon()}
        />
      </div>
    </div>
  );
}

export default BusinessServices;
